/**
 * Deal validation schemas using Zod
 */

import { z } from 'zod';

export const CreateDealSchema = z.object({
  brandId: z.string({ required_error: 'Brand ID is required' }).min(1, 'Brand ID is required'),
  dealName: z
    .string({ required_error: 'Deal name is required' })
    .min(1, 'Deal name is required')
    .max(200, 'Deal name must be at most 200 characters'),
  dealValue: z
    .number({ required_error: 'Deal value is required' })
    .min(0, 'Deal value cannot be negative')
    .max(10000000, 'Deal value exceeds maximum'),
  currency: z.string().length(3, 'Currency must be 3-letter code').default('USD'),
  startDate: z.string().datetime().optional(),
  endDate: z.string().datetime().optional(),
  description: z.string().max(2000).optional(),
  priority: z.enum(['low', 'medium', 'high', 'urgent']).default('medium'),
});

export const UpdateDealSchema = z.object({
  dealName: z
    .string()
    .min(1, 'Deal name is required')
    .max(200, 'Deal name must be at most 200 characters')
    .optional(),
  dealValue: z
    .number()
    .min(0, 'Deal value must be positive')
    .max(10000000, 'Deal value exceeds maximum')
    .optional(),
  currency: z.string().length(3, 'Currency must be 3-letter code').optional(),
  startDate: z.string().datetime().optional(),
  endDate: z.string().datetime().optional(),
  description: z.string().max(2000).optional(),
  priority: z.enum(['low', 'medium', 'high', 'urgent']).optional(),
});

export const UpdateDealStageSchema = z.object({
  stage: z.enum([
    'pitching',
    'negotiating',
    'contract_signed',
    'content_in_progress',
    'awaiting_payment',
    'completed',
  ]),
  note: z.string().max(500).optional(),
});
